import api from "../api";

export type RequestPayload = {
  title: string;
  fullName: string;
  phone: string;
  email: string;
  file?: string;
};

const REQUEST_URL = `/dash/medical/request`;

export async function sendRequest(payload: RequestPayload): Promise<void> {
  await api.post(REQUEST_URL, payload);
}

export default api;
